module.exports = __webpack_public_path__ + "media/band.c9786438.mp4";